var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({attrs:{"color":_vm.active ? 'success' : 'warning'}},'v-chip',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.status)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }